import { useContext, useState, useEffect, useRef } from 'react'

import { withStyles } from '@material-ui/core/styles'
import { Box, Typography, Grid } from '@material-ui/core'
import styles from '../dashboardStyles'

import { reducerContext } from '../../../../../contextApi\'s/contextApi\'s'

import Group12 from '../../../../../ui-assets/Group12.svg'



const DailPadOne = ({ classes, isCallActive }) => {

    const { state, dispatch } = useContext(reducerContext)
    const { customerPhoneNumber } = state

    const [phoneNumber, setPhoneNumber] = useState('')
    const [isClicked, setIsClicked] = useState('')
    const [callActive, setCallActive] = useState(false)
    // srini - 14/11/24
    const phoneNumberRef = useRef(phoneNumber)
    const callActiveRef = useRef(callActive)

    const formattedNumber = `${String(customerPhoneNumber).substring(0, 3)} ${String(customerPhoneNumber).substring(3, 6)} ${String(customerPhoneNumber).substring(6, 10)}`

    useEffect(() => {
        phoneNumberRef.current = phoneNumber
    }, [phoneNumber])
    // srini - 14/11/24
    useEffect(() => {
        callActiveRef.current = callActive;
    }, [callActive])

    const handleNumbeAddClick = (num) => {
        if (phoneNumber.length < 10) {
            setPhoneNumber(phoneNumber + num)

            dispatch({
                type: 'SET_CUSTOMER_PHONE_NUMBER',
                payload: phoneNumber + num
            })
        }

        setIsClicked(num)
        // Reset the highlight after a short delay
        setTimeout(() => setIsClicked(''), 200)
    }

    const handleNumberRemoveClick = () => {
        if (phoneNumber.length > 0) {
            setPhoneNumber(phoneNumber.slice(0, -1));

            dispatch({
                type: 'SET_CUSTOMER_PHONE_NUMBER',
                payload: phoneNumber.slice(0, -1)
            })
        }
    }
    // Updated the SIP function to use async/await and added error handling - 15/10/24 - Dev Srini
    const handleOutBoundCall = async () => {

        const number = `91${customerPhoneNumber || phoneNumberRef.current}`

        dispatch({
            type: 'SET_OUT_BOUND_CALLING',
            payload: true
        })

        dispatch({
            type: 'SET_ERROR',
            payload: 'Calling'
        })

        window.txtPhoneNumber.value = number

        try {
            await window.sipCall()
            console.log("Call initiated successfully to:", number)

            await window.sipPublish('closed', 'Busy', 'I am with client call')
            console.log("SIP status published: 'Closed' - 'Busy' - 'I am with client call'")

            dispatch({
                type: 'SET_AGENT_PUBLISH_STATS',
                payload: 'closed'
            })
        }
        catch (error) {
            console.error('Error during outbound call or SIP publish status:', error)
        }
    }

    const handleDailPadClose = () => {
        dispatch({
            type: 'SET_CALL_ICON_TOGGLE',
            payload: false
        })

        setPhoneNumber('')

        dispatch({
            type: 'SET_CUSTOMER_PHONE_NUMBER',
            payload: ''
        })
    }
    

    const handleKeyPress = (event) => {
        // srini - 14/11/24
        if (callActiveRef.current) {
            return
        }

        const key = event.key
        
        if (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '#'].includes(key)) {
            setPhoneNumber((prev) => {
                const newPhoneNumber = prev + key

                dispatch({
                    type: 'SET_CUSTOMER_PHONE_NUMBER',
                    payload: newPhoneNumber,
                })

                return newPhoneNumber
            })


        }
        else if (key === 'Backspace' || key === 'Delete') {
            setPhoneNumber((prev) => {
                const updatePhoneNumber = prev.slice(0, -1)

                dispatch({
                    type: 'SET_CUSTOMER_PHONE_NUMBER',
                    payload: updatePhoneNumber,
                })

                return updatePhoneNumber
            })
        }
        else if (key === 'Enter') {
            phoneNumberRef.current.length === 10 && handleOutBoundCall()
        }
    }

    useEffect(() => {
        window.addEventListener('keydown', handleKeyPress)

        return () => {
            window.removeEventListener('keydown', handleKeyPress)
        }
    }, [])
    // srini - 14/11/24
    useEffect(() => {
        if (isCallActive) {
            setCallActive(true)
        }
        else{
            setCallActive(false)
        }
    }, [isCallActive])


    return (
        <div style={{ position: 'fixed', top: 130, right: 20, }}>
            <div style={{ color: 'white', width: '100%', height: '608px', background: '#131E2E', border: '1px solid #00ACFE', borderRadius: '8px' }}>
                <div
                    style={{
                        width: '94%',
                        height: '60px',
                        margin: '5% 2% 0 3%',
                        display: 'flex',
                        flexShrink: 0,
                        borderRadius: '4px',
                        background: '#000',
                    }}
                >
                    <div style={{ flex: 1 }}>
                        <Typography className={classes.lastcall_text} style={{ margin: '4% 0 0 10%' }}>Last Call</Typography>
                        <Typography className={classes.lastcall_text} style={{ margin: '4% 0 0 10%' }}>+91 ----------</Typography>
                    </div>

                    <div style={{ flex: 1 }}>
                        <Typography className={classes.lastcall_text} style={{ margin: '4% 0 0 38%' }}>Time</Typography>
                        <Typography className={classes.lastcall_text} style={{ margin: '4% 0 0 38%' }}>00:00:00</Typography>
                    </div>
                    <div
                        className={classes.dailPadClose}
                        onClick={handleDailPadClose}
                    >
                        X
                    </div>
                </div>

                <div style={{
                    width: '308px',
                    height: '506px',
                    flexShrink: 0,
                    backgroundColor: '#043068',
                    margin: '3% 0 0 0%',
                    borderRadius: '2%'
                }}>
                    <span style={{ margin: '1%' }}></span>
                    <div style={{
                        width: '282px',
                        height: '186px',
                        flexShrink: 0,
                        background: 'conic-gradient(from 180deg at 50% 50%, #82B9FF 0deg, rgba(130, 185, 255, 0.00) 360deg)',
                        border: '6px solid #062C5B',
                        borderRadius: '15px',
                        margin: '1% 0 0 2%',
                    }} >

                        <Typography className={classes.ongoingtext}>Outgoing call</Typography>

                        <Typography className={classes.ongoingtext2} style={{ marginTop: '8%' }}>{customerPhoneNumber ? `+91 ${formattedNumber}` : `+91 ----------`}</Typography>
                    </div>

                    <div style={{ marginTop: '20px' }}>
                        <Grid container spacing={1}>
                            <Box
                                onClick={() => handleNumbeAddClick('1')}
                                sx={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: '50%',
                                    backgroundColor: isClicked == '1' ? '#1B559C' : '#062C5B',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: '6%',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s ease',
                                }}
                            >
                                <Typography>
                                    <span style={{ color: 'white', fontWeight: 'bold', fontFamily: 'cardiuma-Regular', fontSize: '14px' }}>1</span>
                                </Typography>
                            </Box>

                            <Box
                                onClick={() => handleNumbeAddClick('2')}
                                sx={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: '50%',
                                    backgroundColor: isClicked == '2' ? '#1B559C' : '#062C5B',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: '12%',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s ease',
                                }}
                            >
                                <Typography>
                                    <span style={{ color: 'white', fontWeight: 'bold', fontFamily: 'cardiuma-Regular', fontSize: '14px' }}>2</span>
                                </Typography>
                            </Box>

                            <Box
                                onClick={() => handleNumbeAddClick('3')}
                                sx={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: '50%',
                                    backgroundColor: isClicked == '3' ? '#1B559C' : '#062C5B',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: '12%',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s ease',
                                }}
                            >
                                <Typography>
                                    <span style={{ color: 'white', fontWeight: 'bold', fontFamily: 'cardiuma-Regular', fontSize: '14px' }}>3</span>
                                </Typography>
                            </Box>

                            <Box
                                onClick={() => handleNumbeAddClick('4')}
                                sx={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: '50%',
                                    backgroundColor: isClicked == '4' ? '#1B559C' : '#062C5B',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: '12%',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s ease',
                                }}
                            >
                                <Typography>
                                    <span style={{ color: 'white', fontWeight: 'bold', fontFamily: 'cardiuma-Regular', fontSize: '14px' }}>4</span>
                                </Typography>
                            </Box>
                        </Grid>
                    </div>

                    <div style={{ marginTop: '25px' }}>
                        <Grid container spacing={1}>
                            <Box
                                onClick={() => handleNumbeAddClick('5')}
                                sx={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: '50%',
                                    backgroundColor: isClicked == '5' ? '#1B559C' : '#062C5B',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: '6%',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s ease',
                                }}
                            >
                                <Typography>
                                    <span style={{ color: 'white', fontWeight: 'bold', fontFamily: 'cardiuma-Regular', fontSize: '14px' }}>5</span>
                                </Typography>
                            </Box>

                            <Box
                                onClick={() => handleNumbeAddClick('6')}
                                sx={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: '50%',
                                    backgroundColor: isClicked == '6' ? '#1B559C' : '#062C5B',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: '12%',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s ease',
                                }}
                            >
                                <Typography>
                                    <span style={{ color: 'white', fontWeight: 'bold', fontFamily: 'cardiuma-Regular', fontSize: '14px' }}>6</span>
                                </Typography>
                            </Box>

                            <Box
                                onClick={() => handleNumbeAddClick('7')}
                                sx={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: '50%',
                                    backgroundColor: isClicked == '7' ? '#1B559C' : '#062C5B',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: '12%',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s ease',
                                }}
                            >
                                <Typography>
                                    <span style={{ color: 'white', fontWeight: 'bold', fontFamily: 'cardiuma-Regular', fontSize: '14px' }}>7</span>
                                </Typography>
                            </Box>

                            <Box
                                onClick={() => handleNumbeAddClick('8')}
                                sx={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: '50%',
                                    backgroundColor: isClicked == '8' ? '#1B559C' : '#062C5B',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: '12%',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s ease',
                                }}
                            >
                                <Typography>
                                    <span style={{ color: 'white', fontWeight: 'bold', fontFamily: 'cardiuma-Regular', fontSize: '14px' }}>8</span>
                                </Typography>
                            </Box>
                        </Grid>
                    </div>

                    <div style={{ marginTop: '30px' }}>
                        <Grid container spacing={1}>
                            <Box
                                onClick={() => handleNumbeAddClick('9')}
                                sx={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: '50%',
                                    backgroundColor: isClicked == '9' ? '#1B559C' : '#062C5B',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: '6%',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s ease',
                                }}
                            >
                                <Typography>
                                    <span style={{ color: 'white', fontWeight: 'bold', fontFamily: 'cardiuma-Regular', fontSize: '14px' }}>9</span>
                                </Typography>
                            </Box>

                            <Box
                                onClick={() => handleNumbeAddClick('0')}
                                sx={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: '50%',
                                    backgroundColor: isClicked == '0' ? '#1B559C' : '#062C5B',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: '12%',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s ease',
                                }}
                            >
                                <Typography>
                                    <span style={{ color: 'white', fontWeight: 'bold', fontFamily: 'cardiuma-Regular', fontSize: '14px' }}>0</span>
                                </Typography>
                            </Box>

                            <Box
                                onClick={() => handleNumbeAddClick('#')}
                                sx={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: '50%',
                                    backgroundColor: isClicked == '#' ? '#1B559C' : '#062C5B',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: '12%',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s ease',
                                }}
                            >
                                <Typography>
                                    <span style={{ color: 'white', fontWeight: 'bold', fontFamily: 'cardiuma-Regular', fontSize: '14px' }}>#</span>
                                </Typography>
                            </Box>

                            <Box
                                onClick={() => handleNumberRemoveClick('x')}
                                sx={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: '50%',
                                    backgroundColor: isClicked == 'x' ? '#1B559C' : '#062C5B',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: '12%',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s ease',
                                }}
                            >
                                <Typography>
                                    <span style={{ color: 'white', fontWeight: 'bold', fontFamily: 'cardiuma-Regular', fontSize: '14px' }}>x</span>
                                </Typography>
                            </Box>
                        </Grid>
                    </div>

                    <div
                        style={{
                            width: '282px',
                            height: '58px',
                            flexShrink: 0,
                            background: 'conic-gradient(from 0deg at 100% 100%, #82B9FF 0%, #043068 100%)',
                            border: '6px solid #062C5B',
                            borderRadius: '45px',
                            marginLeft: '5px',
                            marginTop: '25px'
                        }}
                    >
                        <img
                            src={Group12}
                            alt='call icon'
                            style={{ paddingTop: '8px', paddingLeft: '120px', cursor: 'pointer' }}
                            onClick={() => phoneNumber.length === 10 && handleOutBoundCall()}
                        />
                    </div>

                </div>
            </div>
        </div >
    )
}

export default withStyles(styles)(DailPadOne)